import Vue from 'vue';
import { login } from '@tencent/vft-common';
Vue.mixin({
  methods: {
    _openLogin: function _openLogin(jumpUrl) {
      this.$openLogin({
        title: '登录态已过期，请重新登录',
        jumpUrl: jumpUrl || location.href
      });
    },
    _switchLogin: function _switchLogin() {
      this.$openLogin({
        title: '选择你要切换的帐号类型'
      });
    },
    strictLoginCall: function strictLoginCall(cb, jumpUrl) {
      var _this = this;

      if (typeof cb === 'function') {
        login.isStrictLogin(function (isLogin) {
          if (isLogin) {
            cb();
          } else {
            _this._openLogin(jumpUrl);
          }
        });
      }
    }
  }
});